import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div className="legal">
      <header className="legal__header">
        <button className="legal__back" onClick={() => navigate(-1)} aria-label="Terug">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7" />
          </svg>
        </button>
        <h1 className="legal__title">Privacyverklaring</h1>
        <span className="legal__spacer" />
      </header>

      <main className="legal__main">
        <h2 className="legal__h1">WalkIn Privacyverklaring</h2>
        <p className="legal__meta">Laatst bijgewerkt: mei 2026</p>

        <p className="legal__lede">WalkIn respecteert uw privacy volledig.</p>

        <h3>1. We slaan geen persoonlijke data op</h3>
        <p>
          Geen naam, e-mail, telefoon, locatiegeschiedenis, browsegedrag of
          tracking cookies.
        </p>

        <h3>2. Locatiegegevens</h3>
        <p>
          Alleen gebruikt om nabijheid te bepalen. NOOIT opgeslagen, gedeeld of
          voor advertenties.
        </p>

        <h3>3. Hoe het werkt</h3>
        <p>
          Digitale etalage — iedereen ziet dezelfde deals. U wordt niet herkend
          of gevolgd.
        </p>

        <h3>4. Anoniem model</h3>
        <p>
          Geen account nodig. Geen sporen. Technisch onmogelijk om u te volgen
          — dat is een bewuste keuze.
        </p>

        <h3>5. QR codes</h3>
        <p>
          Willekeurig gegenereerd. Niet aan identiteit gekoppeld. Na gebruik
          verwijderd.
        </p>

        <h3>6. Winkeliers</h3>
        <p>
          AVG/GDPR conform. Zien statistieken maar NOOIT wie de klanten zijn.
        </p>

        <h3>7. Contact</h3>
        <p>
          privacy@walkin.nl<br />
          WalkIn B.V. · Amsterdam, Nederland
        </p>

        <p className="legal__quote">
          "Voorbijgangers worden klanten. Niemand wordt gevolgd."
        </p>
      </main>
    </div>
  );
}
